import { Users2 } from 'lucide-react';
import { industries } from './constants';
import { useLang } from '../../contexts/LanguageContext';

export const IndustriesSection = () => {
  const { t } = useLang('industries');

  return (
    <section id="industries" className="py-24 px-4 sm:px-6 lg:px-8 bg-[#0a0a0a]">
      <div className="max-w-7xl mx-auto">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div>
            <div className="flex items-center gap-2 mb-4">
              <span className="h-1 w-8 bg-[#00CED1] rounded-full" />
              <span className="text-xs font-semibold uppercase tracking-[0.2em] text-[#00CED1]">{t.eyebrow}</span>
            </div>
            <h2 className="text-3xl sm:text-4xl font-bold tracking-tight mb-6 text-white">
              {t.title}
            </h2>
            <p className="text-lg text-white/40 mb-8">
              {t.subtitle}
            </p>
            <div className="grid sm:grid-cols-2 gap-4">
              {industries.map((iconRow, i) => {
                const Icon = iconRow.icon;
                const name = t.names?.[i] || iconRow.name;
                return (
                  <div key={name} className="flex items-center gap-4 p-4 border border-white/[0.06] rounded-xl hover:border-[#00CED1]/30 bg-white/[0.02] transition-colors">
                    <div className="w-12 h-12 rounded-lg flex items-center justify-center bg-[#00CED1]/10">
                      <Icon className="h-6 w-6 text-[#00CED1]" />
                    </div>
                    <div>
                      <h4 className="font-semibold text-white">{name}</h4>
                      <p className="text-sm text-white/30">{t.sub}</p>
                    </div>
                  </div>
                );
              })}
            </div>
          </div>
          <div className="relative">
            <img
              src="/marketing/kanriva/capacity.jpg"
              alt="Kanriva™ — workload demand vs coverage (demo data)"
              loading="lazy"
              className="rounded-xl shadow-2xl shadow-[#00CED1]/5 border border-white/10"
            />
            <div className="absolute -bottom-6 -left-6 bg-[#111111] p-6 rounded-xl shadow-lg border border-white/10">
              <div className="flex items-center gap-3">
                <div className="w-12 h-12 rounded-full bg-[#00CED1]/15 flex items-center justify-center">
                  <Users2 className="h-6 w-6 text-[#00CED1]" />
                </div>
                <div>
                  <p className="text-2xl font-bold text-white">{t.badgeTitle}</p>
                  <p className="text-sm text-white/40">{t.badgeSub}</p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};
